export function clearFaqs(state) {
  state.faqs = undefined;
}
export function setFaqs(state, payload) {
  state.faqs = payload;
}
